import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed, ref, shallowRef } from 'vue'

export const useMapStore = defineStore('map', () => {
  const layers = ref({
    base: [],
    info: [],
    overlays: [],
  })
  const features = ref([])
  const selected = ref([])
  const activeBaseLayer = ref(null)
  const activeInfoLayers = ref([])
  const styleSelectedId = ref(null)
  const label = ref(null)
  const loading = ref(false)
  const heatmapEnabled = ref(false)
  const heatmapField = ref('tehingusumma')
  const viewport = shallowRef({
    center: null,
    zoom: null,
    extent: null,
  })

  const setFeatures = features => {
    features.value = features
  }

  const setSelected = features => {
    if (Array.isArray(features)) {
      selected.value = features
    } else {
      selected.value = [features]
    }
  }

  const getLayers = computed(() => {
    return layers.value
  })
  const getFeatures = computed(() => {
    return features.value
  })
  const getSelected = computed(() => {
    return selected.value
  })
  const getActiveBaseLayer = computed(() => {
    return activeBaseLayer.value
  })
  const getActiveInfoLayers = computed(() => {
    return activeInfoLayers.value
  })
  const getStyleSelectedId = computed(() => {
    return styleSelectedId.value
  })
  const getLabel = computed(() => {
    return label.value
  })

  return {
    getLayers,
    getFeatures,
    setFeatures,
    getSelected,
    setSelected,
    getActiveBaseLayer,
    getActiveInfoLayers,
    getStyleSelectedId,
    getLabel,
    layers,
    features,
    selected,
    activeBaseLayer,
    activeInfoLayers,
    styleSelectedId,
    label,
    loading,
    viewport,
    heatmapEnabled,
    heatmapField,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMapStore, import.meta.hot))
}
